import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";

const sections = [
  {
    title: "Sell and track every ticket",
    body: "Sell bracket tickets from the team and bracket screens. Each bowler's ticket count stays together as you manage the field.",
  },
  {
    title: "Fill the trees in one step",
    body: "Close ticket sales and shuffle. The 8-player trees fill automatically, with leftover tickets identified for refunds.",
  },
  {
    title: "Use the scores you already entered",
    body: "Brackets use the games posted through Scoring. There is no separate bracket scoring to maintain.",
  },
  {
    title: "Know who gets paid",
    body: "After Game 3, see the winners and what they are owed. Prizes shows who still needs to be paid.",
  },
];

const BowlingBracketSoftware = () => (
  <ProductPage
    title="Bowling Bracket Software | Bowling Tournament App"
    description="Sell tickets, fill the trees, and know who won and who gets paid. Scratch and handicap stay separate."
    keywords={[
      "bowling bracket software",
      "bowling brackets software",
      "bowling tournament brackets",
      "8-player bowling brackets",
      "scratch bowling brackets",
      "handicap bowling brackets",
    ]}
    canonicalUrl="/bowling-bracket-software"
    heading="Run the bracket without running the paperwork"
    lede="Sell tickets, fill the trees, and know who won and who gets paid. Scratch and handicap stay separate."
    analyticsLocation="bowling_bracket_software"
    secondaryTo="/support/tutorials/run-brackets"
    secondaryLabel="How to run brackets"
    sectionHeading="From tickets to payouts"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.brackets}
  />
);

export default BowlingBracketSoftware;
